export const stockHeaders = [
    { name: "Scrip Name" },
    { name: "Price" },
    { name: "Action" },

]
